export const callFunctionWithDefault = (fn, params = [], defaultValue) => {
  if (fn) return fn(...params);
  return defaultValue;
};
